var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallModalHeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 200,
    viewBox: "0 0 1800 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25068_353535)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 200,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_25068_353535)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.804,
    y: -87.3377,
    width: 1444.18,
    height: 348,
    fill: "#BEEAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.6998 -51.2003C-53.2002 -80.3493 -22.9251 -100.42 20.5133 -101.062L926.377 -114.455C954.371 -114.869 984.589 -107.107 1009.84 -93.0176L1149.6 -15.0201C1216.43 22.2734 1220.06 84.7368 1156.39 101.806L92.7606 386.945C21.4152 406.071 -75.5593 354.258 -72.6929 298.543L-54.6998 -51.2003Z",
    fill: "#9DE0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.94 138.795C1001.86 100.897 1049.46 -34.6254 1150.32 -33.0963L1996.98 -20.2602C2040.1 -19.6064 2072.87 10.3362 2075.65 51.6265L2085.24 194.064C2089 249.926 2037.47 301.827 1979.13 300.943L1465.68 293.158C1454.06 292.982 1442.88 290.649 1432.73 286.284L1089.94 138.795Z",
    fill: "#9DE0F4"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 200,
    fill: "url(#paint0_linear_25068_353535)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.812 25.6686C616.873 33.1376 592.529 33.3409 588.417 33.1952C530.782 31.1626 509.405 42.2349 453.032 59.2554C385.789 79.5603 352.216 158.772 132.449 161.113C73.0069 161.748 124.981 59.3528 112.472 21.5387C87.1505 -54.9979 -67.2146 -101.299 -33.8239 -198.234C6.38715 -314.97 203.241 -325.872 297.118 -280.954C353.882 -253.791 399.766 -207.906 460.567 -188.651C513.657 -171.834 620.444 -175.727 660.102 -140.631C710.896 -95.6781 674.253 -2.49878 623.353 28.2931",
    fill: "url(#paint1_linear_25068_353535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.812 25.6686C616.873 33.1376 592.529 33.3409 588.417 33.1952C530.782 31.1626 509.405 42.2349 453.032 59.2554C385.789 79.5603 352.216 158.772 132.449 161.113C73.0069 161.748 124.981 59.3528 112.472 21.5387C87.1505 -54.9979 -67.2146 -101.299 -33.8239 -198.234C6.38715 -314.97 203.241 -325.872 297.118 -280.954C353.882 -253.791 399.766 -207.906 460.567 -188.651C513.657 -171.834 620.444 -175.727 660.102 -140.631C710.896 -95.6781 674.253 -2.49879 623.353 28.2931",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M49.7247 -53.1406C55.7977 -83.7797 63.9047 -116.288 61.5314 -140.71C56.3789 -193.702 108.854 -213.19 152.747 -216.516C233.708 -222.696 310.72 -190.215 391.241 -194.366C404.562 -195.098 417.776 -197.165 430.683 -200.538C473.359 -211.446 510.846 -233.639 554.625 -245.936C587.251 -255.104 668.488 -267.177 679.119 -219.948L683.912 -207.474C684.019 -207.478 684.012 -207.512 684.108 -207.379C697.235 -188.882 711.55 -155.744 696.412 -135.278C690.995 -127.958 685.26 -120.455 679.202 -112.925C657.218 -85.5996 631.042 -57.9519 600.957 -37.4241C581.224 -23.9639 573.094 5.9528 563.273 33.2223C557.258 49.9253 550.606 65.635 540.255 75.9591C476.522 139.572 403.011 168.181 330.089 187.181L294.921 190.678C238.176 190.39 216.681 174.688 210.113 163.377C208.874 161.242 207.564 159.097 206.184 156.944C184.583 123.249 145.995 87.4576 111.966 62.9449C94.1453 50.0982 77.5786 40.3509 65.3578 35.6375C37.2214 24.7113 41.6891 -12.5779 49.7247 -53.1406Z",
    fill: "url(#paint2_linear_25068_353535)",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1237.55 87.6682C1236.65 96.3467 1209.27 89.7637 1204.7 88.4494C1140.59 70.0425 1113.5 76.4867 1045.48 79.814C964.336 83.7859 904.498 163.284 657.22 104.421C590.336 88.5018 677.311 -11.8641 673.854 -57.7989C666.853 -150.773 506.579 -245.923 571.172 -345.361C648.959 -465.111 872.919 -422.267 965.7 -345.593C1021.8 -299.228 1060.45 -234.898 1123.3 -196.279C1178.17 -162.552 1299.09 -137.042 1333.78 -86.5616C1378.2 -21.9032 1311.01 72.4103 1245.28 92.7233",
    fill: "url(#paint3_linear_25068_353535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.55 87.6682C1236.65 96.3467 1209.27 89.7637 1204.7 88.4494C1140.59 70.0425 1113.5 76.4867 1045.48 79.814C964.336 83.7859 904.498 163.284 657.22 104.421C590.336 88.5018 677.311 -11.8641 673.854 -57.7989C666.853 -150.773 506.579 -245.923 571.172 -345.361C648.959 -465.111 872.919 -422.267 965.7 -345.593C1021.8 -299.228 1060.45 -234.898 1123.3 -196.279C1178.17 -162.552 1299.09 -137.042 1333.78 -86.5616C1378.2 -21.9032 1311.01 72.4103 1245.28 92.7233",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M624.335 -159.161C639.722 -191.845 657.916 -226.058 662.085 -254.127C671.13 -315.037 735.47 -322.224 785.658 -313.675C878.242 -297.958 955.576 -239.961 1047.1 -222.089C1062.25 -219.183 1077.66 -217.806 1093.09 -217.979C1144.03 -218.28 1192.31 -232.696 1244.88 -234.247C1284.05 -235.406 1378.6 -226.225 1377.31 -170.249L1379.2 -154.911C1379.32 -154.885 1379.32 -154.925 1379.39 -154.749C1388.95 -130.319 1395.74 -89.1259 1373.03 -70.395C1364.9 -63.6955 1356.37 -56.8812 1347.46 -50.1255C1315.15 -25.6118 1278.03 -1.90963 1238.53 12.7091C1212.62 22.2928 1195.13 53.5907 1176.47 81.4445C1165.05 98.5056 1153.19 114.274 1138.69 122.964C1049.37 176.518 958.867 188.054 871.718 188.972L831.275 183.058C767.676 166.858 747.948 143.222 743.742 128.692C742.949 125.948 742.079 123.176 741.132 120.373C726.319 76.5165 693.031 25.5548 661.702 -11.4746C645.298 -30.8773 629.434 -46.451 617.038 -55.1597C588.521 -75.2936 603.968 -115.889 624.335 -159.161Z",
    fill: "url(#paint4_linear_25068_353535)",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.45 -114.566C1897.16 -122.86 1869.47 -127.981 1864.76 -128.641C1798.71 -137.901 1776.58 -154.805 1715.79 -185.513C1643.28 -222.144 1620.95 -319.108 1371.11 -365.911C1303.53 -378.572 1342.17 -251.508 1320.33 -210.95C1276.11 -128.861 1091 -107.127 1109.56 9.98641C1131.91 151.022 1353.94 202.975 1469.88 170.667C1539.99 151.13 1601.47 108.082 1674.59 98.3623C1738.43 89.8695 1859.28 115.751 1911.5 83.7418C1978.38 42.7416 1955.36 -70.7472 1903.57 -116.041",
    fill: "url(#paint5_linear_25068_353535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.45 -114.566C1897.16 -122.86 1869.47 -127.981 1864.76 -128.641C1798.71 -137.901 1776.58 -154.805 1715.79 -185.513C1643.28 -222.144 1620.95 -319.108 1371.11 -365.911C1303.53 -378.572 1342.17 -251.508 1320.33 -210.95C1276.11 -128.861 1091 -107.127 1109.56 9.9864C1131.91 151.022 1353.94 202.975 1469.88 170.667C1539.99 151.13 1601.47 108.082 1674.59 98.3623C1738.43 89.8696 1859.28 115.751 1911.5 83.7418C1978.38 42.7416 1955.36 -70.7472 1903.57 -116.041",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1233.86 -138.493C1234.62 -102.376 1237.33 -63.7208 1229.72 -36.3822C1213.21 22.9404 1269.06 55.6761 1318.39 68.2792C1409.36 91.5781 1503.6 70.0495 1594.48 90.9486C1609.5 94.4572 1624.14 99.4659 1638.16 105.899C1684.58 126.894 1722.82 159.701 1770.21 182.499C1805.53 199.493 1895.64 229.56 1917.23 177.901L1925.19 164.657C1925.32 164.683 1925.3 164.72 1925.44 164.588C1944.1 146.156 1967.06 111.287 1953.93 84.9372C1949.23 75.5108 1944.21 65.8143 1938.82 56.0208C1919.27 20.4824 1895 -16.2651 1864.86 -45.6879C1845.09 -64.982 1841.84 -100.689 1836.13 -133.721C1832.63 -153.954 1828.21 -173.183 1818.49 -187.021C1758.68 -272.275 1680.7 -319.623 1601.45 -355.909L1562.1 -366.955C1497.41 -378.023 1469.78 -364.455 1460.02 -352.892C1458.18 -350.709 1456.26 -348.529 1454.26 -346.354C1422.89 -312.314 1371.75 -279.298 1328.07 -258.212C1305.19 -247.159 1284.36 -239.384 1269.5 -236.47C1235.25 -229.676 1232.85 -186.307 1233.86 -138.493Z",
    fill: "url(#paint6_linear_25068_353535)",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1971.41 -415.024C1979.8 -412.631 1968.57 -386.815 1966.48 -382.538C1937.22 -322.6 1938.86 -294.805 1930.33 -227.236C1920.15 -146.638 1988.05 -73.904 1887.14 159.396C1859.85 222.499 1776.11 119.417 1730.27 114.845C1637.5 105.595 1515.96 246.911 1429.25 166.032C1324.83 68.6327 1405.91 -144.485 1497.53 -222.542C1552.93 -269.74 1623 -296.634 1671.94 -351.816C1714.68 -399.998 1760.8 -514.657 1816.54 -540.049C1887.93 -572.569 1969.14 -490.021 1977.73 -421.757",
    fill: "url(#paint7_linear_25068_353535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.41 -415.024C1979.8 -412.631 1968.57 -386.815 1966.48 -382.538C1937.22 -322.6 1938.86 -294.805 1930.33 -227.236C1920.15 -146.638 1988.05 -73.904 1887.14 159.396C1859.85 222.499 1776.11 119.417 1730.27 114.845C1637.5 105.595 1515.96 246.911 1429.25 166.032C1324.83 68.6327 1405.91 -144.485 1497.53 -222.542C1552.93 -269.74 1623 -296.634 1671.94 -351.816C1714.68 -399.998 1760.8 -514.657 1816.54 -540.049C1887.93 -572.569 1969.14 -490.021 1977.73 -421.757",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1621.85 146.011C1592.34 125.181 1561.8 101.323 1534.88 92.3429C1476.47 72.8586 1480.56 8.24808 1497.7 -39.6926C1529.25 -128.14 1599.8 -194.229 1633.29 -281.258C1638.79 -295.676 1642.82 -310.61 1645.33 -325.834C1653.88 -376.055 1648.06 -426.103 1655.66 -478.143C1661.32 -516.927 1686.78 -608.439 1741.69 -597.453L1757.12 -596.649C1757.17 -596.765 1757.13 -596.774 1757.31 -596.812C1783.03 -601.981 1824.78 -601.516 1839.28 -575.895C1844.46 -566.727 1849.69 -557.139 1854.8 -547.197C1873.33 -511.115 1890.23 -470.452 1897.76 -429.009C1902.7 -401.827 1930.49 -379.165 1954.68 -355.96C1969.5 -341.747 1982.97 -327.33 1989.01 -311.536C2026.24 -214.274 2021.88 -123.146 2007.65 -37.1615L1994.81 1.64032C1967.81 61.46 1941.11 76.784 1926.07 78.4026C1923.23 78.7078 1920.35 79.0831 1917.42 79.5283C1871.66 86.5009 1815.69 110.434 1773.78 134.857C1751.83 147.643 1733.73 160.561 1723.01 171.256C1698.23 195.844 1660.93 173.582 1621.85 146.011Z",
    fill: "url(#paint8_linear_25068_353535)",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_25068_353535",
    x: -172.755,
    y: -214.471,
    width: 2358.19,
    height: 705.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_25068_353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25068_353535",
    x1: 911.757,
    y1: 200,
    x2: 911.757,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25068_353535",
    x1: 676.695,
    y1: -144.774,
    x2: -21.5087,
    y2: -46.1511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25068_353535",
    x1: 706.976,
    y1: -41.8866,
    x2: 43.1262,
    y2: -18.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25068_353535",
    x1: 1353.56,
    y1: -86.5681,
    x2: 542.44,
    y2: -171.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25068_353535",
    x1: 1358.75,
    y1: 37.3648,
    x2: 607.295,
    y2: -122.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25068_353535",
    x1: 1929.57,
    y1: 91.793,
    x2: 1154.13,
    y2: -160.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25068_353535",
    x1: 1984.72,
    y1: -19.3131,
    x2: 1233.26,
    y2: -179.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25068_353535",
    x1: 1819.97,
    y1: -559.53,
    x2: 1595.73,
    y2: 224.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25068_353535",
    x1: 1942.92,
    y1: -543.123,
    x2: 1655.13,
    y2: 169.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C8EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25068_353535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallModalHeader);
export default __webpack_public_path__ + "static/media/InstallModalHeader.68ccea68d7e3c3ad4be1ebc901223040.svg";
export { ForwardRef as ReactComponent };